<h1>Souhlas se zpracováním osobních údajů</h1>

<ol>

  <li>

    <p>
      Udělujete  tímto  souhlas  společnosti  Městská nemocnice Čáslav,  se  sídlo  Jeníkovská 348, 286 01 Čáslav,  IČ: 00873764 (dále  jen  „Správce“),  aby  ve  smyslu nařízení Evropského  parlamentu  a  Rady  (EU) č.  2016/679  o ochraně  fyzických  osob  v  souvislosti  se zpracováním  osobních údajů  a  o  volném  pohybu těchtoúdajů  a  o  zrušení směrnice  95/46/ES (obecné  nařízení  o  ochraně  osobních  údajů)  (dále  jen  „Nařízení“)  zpracovávala  tyto  osobní údaje:
    </p>

    <ul>
      <li>jméno a příjmení</li>
      <li>e-mail</li>
      <li>telefonní číslo</li>
      <li>rodné číslo</li>
      <li>krevní skupina</li>
      <li>datum narození</li>
    </ul>

  </li>
  <li>

    <p>
      Jméno, příjmení, e-mail, telefonní číslo, rodné číslo, krevní skupina  a  datum narození je možné zpracovat na základě Vámi uděleného  souhlasu. Tyto  údaje  budou  Správcem zpracovány po dobu 10 let.
    </p>

  </li>
  <li>

    <p>
      Správce shromažďuje  na  svých  webových  stránkách  následující  soubory cookies:
    </p>

    <ul>
      <li>Funkční cookies</li>
      <li>Marketingové cookies</li>
      <li>Výkonnostní cookies</li>
    </ul>
    
  </li>
  <li>

    <p>
      S výše  uvedeným  zpracováním udělujete svůj výslovný  souhlas.  Poskytnutí  osobních údajů  je dobrovolné.  Souhlas  lze  vzít  kdykoliv  zpět,  a  to  například  zasláním  emailu  nebo  dopisu  na kontaktní údaje společnosti.
    </p>

  </li>
  <li>

    <p>
      Zpracování  osobních údajů  je prováděno  Správcem,  osobní  údaje  však  pro  Správce  mohou zpracovávat i tito zpracovatelé:
    </p>

    <ul>
      <li>Poskytovatel softwaru.</li>
      <li>Případně  další  poskytovatelé  zpracovatelských softwarů,  služeb  a  aplikací,  které  však  v současné době společnost nevyužívá.</li>
    </ul>

  </li>
  <li>

    <p>
      Vezměte, prosíme, na vědomí, že podle Nařízení máte právo:
    </p>

    <ul>
      <li>vzít souhlas kdykoliv zpět</li>
      <li>požadovat  po  nás  informaci,  jaké  vaše  osobní  údaje  zpracováváme,  žádat  si  kopii těchto údajů</li>
      <li>vyžádat si u nás přístup k těmto údajům a tyto nechat aktualizovat nebo opravit, popřípadě požadovat omezení zpracování</li>
      <li>požadovat po nás výmaz těchto osobních údajů</li>
      <li>na přenositelnost údajů</li>
      <li>podat stížnost u Úřadu pro ochranu osobních údajů nebo se obrátit na soud</li>
    </ul>

  </li>

<ol>
